import { createContext, useCallback, useState } from "react";
import ReactDOM from 'react-dom';
import AlertDialog from "./AlertDialog";

export const AlertDialogContext = createContext();

export default function AlertDialogProvider({ children }) {
    const [state, setState] = useState({
        isOpen: false
    });

    const open = useCallback((prompt) => {
        setState({
            isOpen: true,
            prompt
        });
    }, []);

    const close = useCallback(() => {
        setState({
            isOpen: false
        })
    }, [])

    return (
        <AlertDialogContext.Provider value={open}>
            {children}
            {state.isOpen
                ? ReactDOM.createPortal(<>
                    <AlertDialog prompt={state.prompt} close={close} />
                </>, document.getElementById("alert-dialog"))
                : <></>
            }
        </AlertDialogContext.Provider>
    )
}
